import {
  TweenMax,
  TimelineLite
} from 'gsap'

export default {
  name: 'home',
  data: function () {
    return {
      activeB: true
    }
  },
  components: {},
  mounted: function () {
    var tl = new TimelineLite({
      paused: true,
      onComplete: function () {
        this.restart()
      }
    })
    tl.to(this.$refs.mouseWheel, 0, {
        opacity: 0,
        y: '-3px'
      })
      .to(this.$refs.mouseWheel, 0.3, {
        opacity: 1,
        y: '0px'
      })
      .fromTo(this.$refs.mouseWheel, 1.8, {
        y: '0px'
      }, {
        y: '6px'
      }, 0)
      .to(this.$refs.mouseWheel, 0.3, {
        opacity: 0
      }, 1.2)
    tl.play()
  },
  computed: {
    english: function () {
      return this.$store.getters.english
    }
  },
  methods: {

  }
}


// WEBPACK FOOTER //
// ./src/components/home/home.js